import { render } from "./PlanTreatmentTemplateDatatableFormServices.vue?vue&type=template&id=5da527a5"
import script from "./PlanTreatmentTemplateDatatableFormServices.vue?vue&type=script&lang=js"
export * from "./PlanTreatmentTemplateDatatableFormServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__